import { Expose } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class Bookkeeping {
  @IsArray()
  @Expose()
  officeProfiles: Array<BookkeepingOfficeProfiles> = [];
  @IsArray()
  @Expose()
  closeMonths: Array<CloseMonths> = [];
}

export class BookkeepingOfficeProfiles {
  @IsOptional()
  @IsNumber()
  @Expose()
  id!: number | null;
  @IsString()
  @Expose()
  name!: string;
}

export class CloseMonths {
  @IsNumber()
  @Expose()
  year!: number;
  @IsNumber()
  @Expose()
  month!: number;
  @IsString()
  @Expose()
  monthName!: string;
  @IsBoolean()
  @Expose()
  canLock!: boolean;
  @IsBoolean()
  @Expose()
  canUnlock!: boolean;
  @IsArray()
  @Expose()
  bookkeepingCloseMonth!: Array<BookkeepingCloseMonth>;
}

export class BookkeepingCloseMonth {
  @IsNumber()
  @Expose()
  bookkeepingCloseMonthId!: number | null;
  @IsNumber()
  @Expose()
  recordStampId!: number | null;
  @IsOptional()
  @IsNumber()
  @Expose()
  officeProfileId!: number;
  @IsString()
  @Expose()
  officeProfileName!: string;
  @IsNumber()
  @Expose()
  year!: number;
  @IsNumber()
  @Expose()
  month!: number;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
}
